import { defineMessages } from 'react-intl';

export const messages: {
	aiDisclaimer: { id: string; defaultMessage: string; description: string };
	selectSite: { id: string; defaultMessage: string; description: string };
	queryAssistantHeading: { id: string; defaultMessage: string; description: string };
	queryAssistantWelcome: { id: string; defaultMessage: string; description: string };
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeChatAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatConversationAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyStateText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	welcomeMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assistantName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	aiDisclaimer: {
		id: 'dtac.graphExplorer.cyphieChat.aiDisclaimer',
		defaultMessage: 'Uses AI. Verify results.',
		description: 'Reminder below the chat input to verify AI generated results.',
	},
	selectSite: {
		id: 'dtac.queryBuilder.queryAssistant.selectSite.ai-non-final',
		defaultMessage: 'Select a site before asking Query Assistant.',
		description: 'Message shown when query generation needs a selected site',
	},
	queryAssistantHeading: {
		id: 'dtac.queryBuilder.queryAssistant.heading.ai-non-final',
		defaultMessage: 'Query Assistant',
		description: 'Name of the Query Builder assistant',
	},
	queryAssistantWelcome: {
		id: 'dtac.queryBuilder.queryAssistant.welcome.ai-non-final',
		defaultMessage:
			"Hi! I'm your Cypher Assistant 👋 I'm here to help you write performant cypher queries for teamwork graph!  You can describe the type of cypher query you want, or send what you have now and we can iterate from there.",
		description: 'Welcome message for the Query Builder assistant',
	},
	heading: {
		id: 'dtac.graphExplorer.cyphieChat.graphExplorerChatAside.heading.non-final',
		defaultMessage: 'Cyphie',
		description: 'Heading text for the Cyphie chat aside panel.',
	},
	closeChatAriaLabel: {
		id: 'dtac.graphExplorer.cyphieChat.graphExplorerChatAside.closeChatAriaLabel.non-final',
		defaultMessage: 'Close chat',
		description: 'Accessible label for the close button on the chat aside panel.',
	},
	chatConversationAriaLabel: {
		id: 'dtac.graphExplorer.cyphieChat.graphExplorerChatAside.chatConversationAriaLabel.non-final',
		defaultMessage: 'Chat conversation',
		description: 'Accessible label for the chat conversation region.',
	},
	emptyStateText: {
		id: 'dtac.graphExplorer.cyphieChat.graphExplorerChatAside.emptyStateText.non-final',
		defaultMessage: 'Ask a question or describe what you want to do.',
		description: 'Placeholder text shown when no messages exist in the chat.',
	},
	welcomeMessage: {
		id: 'dtac.graphExplorer.cyphieChat.graphExplorerChatAside.welcomeMessage.non-final',
		defaultMessage:
			"Hi! I'm Cyphie 👋 I'm here to help you write performant cypher queries for teamwork graph!\n\nYou can describe the type of cypher query you want, or send what you have now and we can iterate from there.",
		description: 'Welcome message shown when the chat is first opened.',
	},
	assistantName: {
		id: 'dtac.graphExplorer.cyphieChat.graphExplorerChatAside.assistantName.non-final',
		defaultMessage: 'Cyphie',
		description: 'Display name for the assistant in chat messages.',
	},
	loadingText: {
		id: 'dtac.graphExplorer.cyphieChat.graphExplorerChatAside.loadingText.non-final',
		defaultMessage: 'Thinking...',
		description: 'Text shown while the assistant is generating a response.',
	},
});
